import { render, staticRenderFns } from "./DSParagraph.vue?vue&type=template&id=4f4df5cc&scoped=true&"
import script from "./DSParagraph.vue?vue&type=script&lang=ts&"
export * from "./DSParagraph.vue?vue&type=script&lang=ts&"
import style0 from "./DSParagraph.vue?vue&type=style&index=0&id=4f4df5cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4df5cc",
  null
  
)

export default component.exports